<template>
  <div class="privacy-container">
    <div class="full d-flex justify-center">
      <div class="navbar d-flex align-center justify-center">
        <img
          src="../assets/img/logo-teman-bakat.png"
          height="50px"
          class="mr-3"
        />
        <v-btn plain class="button-navbar" color="white"
          ><a href="https://temanbakat.id" class="link">Beranda</a></v-btn
        >
        <v-btn plain class="button-navbar" color="white">Produk</v-btn>
        <v-btn plain class="button-navbar" color="white">Bantuan</v-btn>
      </div>
    </div>
    <div class="sub-head" style="display: none">
      <div class="nav-sub">
        <v-btn plain color="black" @click="onItems = 1">Privacy Policy</v-btn>
        <v-btn plain color="black" @click="onItems = 2"
          >Terms and Conditions</v-btn
        >
        <v-btn plain color="black" @click="onItems = 3">FAQ</v-btn>
        <v-btn plain color="black" @click="onItems = 4">Panduan Aplikasi</v-btn>
        <v-btn plain color="black" @click="onItems = 5">Partnership</v-btn>
        <v-btn plain color="black" @click="onItems = 6">Hubungi Kami</v-btn>
      </div>
    </div>
    <div class="select d-flex align-center justify-center pa-4">
      <v-select
        :items="items"
        label="Pilih menu"
        v-model="onItems"
        item-value="id"
        item-text="value"
        @change="selected(onItems)"
        dense
        solo
      ></v-select>
    </div>
    <div class="content-container">
      <PrivacyPolicy v-if="onItems == 1" />
      <TermCondition v-if="onItems == 2" />
      <Faq v-if="onItems == 3" />
      <PanduanApp v-if="onItems == 4" />
      <Partnership v-if="onItems == 5" />
      <ContactUs v-if="onItems == 6" />
    </div>
  </div>
</template>
<script>
import PrivacyPolicy from "../components/privacy/PrivacyPolicy.vue";
import TermCondition from "../components/privacy/TermCondition.vue";
import Faq from "../components/privacy/Faq.vue";
import PanduanApp from "../components/privacy/PanduanApp.vue";
import Partnership from "../components/privacy/Partnership.vue";
import ContactUs from "../components/privacy/ContactUs.vue";

export default {
  name: "privacyPolicy",
  components: {
    PrivacyPolicy,
    TermCondition,
    Faq,
    PanduanApp,
    Partnership,
    ContactUs,
  },
  data: () => ({
    onItems: 1,
    items: [
      { id: 1, value: "Privacy & Policy" },
      { id: 2, value: "Terms and Conditions" },
      { id: 3, value: "FAQ" },
      { id: 4, value: "Panduan Aplikasi" },
      { id: 5, value: "Partnership" },
      { id: 6, value: "Hubungi Kami" },
    ],
  }),
  methods: {
    selected(items) {
      this.onItems = items;
    },
  },
};
</script>

<style scoped>
.navbar {
  padding: 10px;
  background-color: #3b033d;
  max-height: 70px;
}
.button-navbar {
  font-size: 12px !important;
}
.privacy-container {
  background-image: url(../assets/img/background-temanbakat-v1.png);
  background-size: contain;
  background-position: top center;
}
.link {
  color: white;
  text-decoration: none;
}
@media only screen and (min-width: 992px) {
  .full {
    display: flex !important;
    justify-content: flex-start !important;
    padding: 16px 24px 16px 24px;
  }
  .sub-head {
    display: flex !important;
    justify-content: flex-start;
    background-color: #f0e9f4;
    padding: 33px 82px 33px 82px;
  }
  .select {
    display: none !important;
  }
  .content-container {
    padding: 40px 82px 40px 82px;
  }
  .privacy-container {
    background-position: center;
  }
}
</style>
